module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Medium.ad231d06.woff";